import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import _ from 'lodash';
import { SkillGroup } from 'src/app/store/samwin/samwin-skills/skill-group';
import { AgentGreetingItem, AgentGreetingItemExpandedState, AudioFileInfo } from 'src/app/store/settings/agent-greeting-settings/agent-greeting-settings.state';

@Component({
   selector: 'samweb-agent-greeting-configuration-list',
   templateUrl: './agent-greeting-configuration-list.component.html',
   styleUrls: ['./agent-greeting-configuration-list.component.scss'],
})
export class AgentGreetingConfigurationListComponent {
   @Input()
   public searchValues: string[];

   @Input()
   public disabled = false;

   @Input()
   public skillList: SkillGroup[];

   @Input()
   public draggedItemKey: AudioFileInfo;

   @Input()
   public availableIci: string[];

   @Output()
   public waveFileDropped = new EventEmitter<AgentGreetingItem>();

   @Output()
   public removeAssignment = new EventEmitter<AgentGreetingItem>();

   @Output()
   public expandGroup = new EventEmitter<AgentGreetingItemExpandedState>();

   @HostListener('wheel', ['$event'])
   onWheel(event: Event) {
      if (!_.isNil(this.draggedItemKey)) {
         event.preventDefault();
      }
   }

   drop(event: AgentGreetingItem) {
      this.waveFileDropped.emit(event);
   }

   remove(event: AgentGreetingItem) {
      this.removeAssignment.emit(event);
   }

   expandIciGroup(event: AgentGreetingItemExpandedState) {
      this.expandGroup.emit(event);
   }
}
